import styled from 'styled-components';
import { preserveCatalogVehicleImageAspectRatio } from 'pages/CatalogPage/common/CatalogHeader/CatalogHeader.styled';

export const SRow = styled.div<{ $isActive?: boolean }>`
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 14px;
  min-height: 72px;
  cursor: pointer;
  box-sizing: border-box;
  transition: background 0.12s;
  border: ${({ $isActive }) => ($isActive ? '2px dashed #7B2FBE' : '1px solid transparent')};
  border-radius: ${({ $isActive }) => ($isActive ? '6px' : '0')};

  &:hover {
    background: ${({ theme }) => theme.color.grey95};
  }

  ${({ $isActive, theme }) =>
    !$isActive &&
    `&:not(:last-child) {
      border-bottom: 1px solid ${theme.color.grey90};
    }`}
`;

export const SThumbnailWrapper = styled.div`
  flex: 0 0 50px;
  width: 50px;
  height: 50px;
  border-radius: 6px;
  overflow: hidden;
  background: ${({ theme }) => theme.color.grey95};
  display: flex;
  align-items: center;
  justify-content: center;

  ${preserveCatalogVehicleImageAspectRatio}
`;

export const SVehicleDetails = styled.div`
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
  justify-content: center;
  gap: 3px;
`;

export const SVehicleName = styled.span`
  font-weight: 700;
  font-size: 14px;
  text-transform: uppercase;
  color: ${({ theme }) => theme.color.grey15};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SFlagColumn = styled.div`
  flex: 0 0 20px;
  width: 20px;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const SVrnColumn = styled.div`
  flex: 0 0 76px;
  width: 76px;
  display: flex;
  align-items: center;
  justify-content: flex-start;
`;

export const SVrn = styled.span`
  font-size: 13px;
  font-weight: 600;
  color: ${({ theme }) => theme.color.grey15};
  white-space: nowrap;
`;

export const SDetailRow = styled.div`
  font-size: 12px;
  color: ${({ theme }) => theme.color.grey15};
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
`;

export const SDetailLabel = styled.span`
  font-weight: 700;
`;

export const SArrow = styled.div`
  flex-shrink: 0;
  display: flex;
  align-items: center;

  svg {
    width: 16px;
    height: 16px;
    fill: ${({ theme }) => theme.color.grey55};
  }
`;
